// extracted by mini-css-extract-plugin
module.exports = {"LayoutViewSwitcher":"LayoutViewSwitcher_LayoutViewSwitcher___6pu_"};